{
  "levels": [
    {
      "id": "unit-counit",
      "name": "Unit/Counit",
      "brief": "Rotate each square until the bridge phase faces the seam, then stitch it into the grid.",
      "targetStitches": 6,
      "squares": [
        {
          "id": "trace-unit",
          "label": "TRACE unit",
          "sdp": "Tr",
          "phase": "η",
          "row": 0,
          "col": 0,
          "rotation": 0,
          "targetRotation": 0,
          "value": 5
        },
        {
          "id": "trace-counit",
          "label": "TRACE counit",
          "sdp": "Tr",
          "phase": "ε",
          "row": 0,
          "col": 1,
          "rotation": 1,
          "targetRotation": 3,
          "value": 6
        },
        {
          "id": "always-unit",
          "label": "ALWAYS unit",
          "sdp": "Al",
          "phase": "η",
          "row": 0,
          "col": 2,
          "rotation": 2,
          "targetRotation": 1,
          "value": 6
        },
        {
          "id": "account-counit",
          "label": "ACCOUNT counit",
          "sdp": "St",
          "phase": "ε",
          "row": 1,
          "col": 0,
          "rotation": 3,
          "targetRotation": 3,
          "value": 5
        },
        {
          "id": "delegate-unit",
          "label": "DELEGATE unit",
          "sdp": "Dt",
          "phase": "η",
          "row": 1,
          "col": 1,
          "rotation": 0,
          "targetRotation": 2,
          "value": 7
        },
        {
          "id": "decompose-counit",
          "label": "DECOMPOSE counit",
          "sdp": "De",
          "phase": "ε",
          "row": 1,
          "col": 2,
          "rotation": 2,
          "targetRotation": 0,
          "value": 6
        }
      ]
    },
    {
      "id": "graded-grid",
      "name": "Graded Grid",
      "brief": "Stitch grade-carrying squares without using the neutral-grade shortcut.",
      "targetStitches": 6,
      "squares": [
        {
          "id": "delegate-counit",
          "label": "DELEGATE counit",
          "sdp": "Dt",
          "phase": "ε",
          "row": 0,
          "col": 0,
          "rotation": 1,
          "targetRotation": 1,
          "value": 5
        },
        {
          "id": "require-unit",
          "label": "REQUIRE unit",
          "sdp": "At",
          "phase": "η",
          "row": 0,
          "col": 1,
          "rotation": 3,
          "targetRotation": 0,
          "value": 6
        },
        {
          "id": "partition-unit",
          "label": "PARTITION unit",
          "sdp": "Pa",
          "phase": "η",
          "row": 0,
          "col": 2,
          "rotation": 0,
          "targetRotation": 2,
          "value": 7
        },
        {
          "id": "account-unit",
          "label": "ACCOUNT unit",
          "sdp": "St",
          "phase": "η",
          "row": 1,
          "col": 0,
          "rotation": 2,
          "targetRotation": 2,
          "value": 5
        },
        {
          "id": "always-counit",
          "label": "ALWAYS counit",
          "sdp": "Al",
          "phase": "ε",
          "row": 1,
          "col": 1,
          "rotation": 0,
          "targetRotation": 3,
          "value": 6
        },
        {
          "id": "trace-unit-b",
          "label": "TRACE unit",
          "sdp": "Tr",
          "phase": "η",
          "row": 1,
          "col": 2,
          "rotation": 1,
          "targetRotation": 0,
          "value": 6
        }
      ]
    },
    {
      "id": "closure-weave",
      "name": "Closure Weave",
      "brief": "Weave six closure squares into a 2D certificate. Unaligned squares cannot be stitched.",
      "targetStitches": 6,
      "squares": [
        {
          "id": "partition-counit",
          "label": "PARTITION counit",
          "sdp": "Pa",
          "phase": "ε",
          "row": 0,
          "col": 0,
          "rotation": 2,
          "targetRotation": 2,
          "value": 5
        },
        {
          "id": "decompose-unit",
          "label": "DECOMPOSE unit",
          "sdp": "De",
          "phase": "η",
          "row": 0,
          "col": 1,
          "rotation": 0,
          "targetRotation": 1,
          "value": 6
        },
        {
          "id": "require-counit",
          "label": "REQUIRE counit",
          "sdp": "At",
          "phase": "ε",
          "row": 0,
          "col": 2,
          "rotation": 3,
          "targetRotation": 0,
          "value": 6
        },
        {
          "id": "trace-counit-b",
          "label": "TRACE counit",
          "sdp": "Tr",
          "phase": "ε",
          "row": 1,
          "col": 0,
          "rotation": 1,
          "targetRotation": 3,
          "value": 7
        },
        {
          "id": "account-counit-b",
          "label": "ACCOUNT counit",
          "sdp": "St",
          "phase": "ε",
          "row": 1,
          "col": 1,
          "rotation": 0,
          "targetRotation": 0,
          "value": 5
        },
        {
          "id": "always-unit-b",
          "label": "ALWAYS unit",
          "sdp": "Al",
          "phase": "η",
          "row": 1,
          "col": 2,
          "rotation": 2,
          "targetRotation": 1,
          "value": 6
        }
      ]
    }
  ]
}
